<template>
	<div class="mytestcard">
		<van-nav-bar title="返回" left-arrow @click-left="onClickLeft" />
		<!-- <van-tabs v-model="active" title-inactive-color='#999999' title-active-color='#60B0E3' line-height='4px' class="tabs">
			<van-tab title="全部" class="item"> -->
		<div class="tabs">
			<div class="item">
				<van-list class="list" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				 <div class="jck">
						<div class="left">新的检测卡</div>
						<div class="txbtn" @click="gofillin">立即填写</div>
					</div>
					<div class="ytxcard" v-for="(item,index) in cardlist" :key='index'>
						<div class="top">
							<div class="title">检测卡<span style="float:right;color:red;font-size: 0.28rem;">{{item.countDown}}天后请再次检测</span></div>
							<div class="nametime"><span>被检测人姓名：{{item.user_name}}</span><span>检测日期：{{item.inspection_date|formatDate}}</span></div>
						</div>
						<div class="bottom">
							<div class="btn retx" @click="rewrite(item)" v-if="index==0">重新填写</div>
							<div class="btn lookread" @click="gomonitoringresults(item.id)">查看结果解读</div>
						</div>
					</div>
				</van-list>
			</div>
		</div>
		<!-- 	</van-tab> -->
		<!-- 	<van-tab title="未填写" class="item">未填写</van-tab>
			<van-tab title="已填写" class="item">已填写</van-tab> -->
		<!-- </van-tabs> -->
	</div>
</template>

<script>
import Vue from 'vue'
import {
  NavBar
  ,
  List
  ,
  Tab,
  Tabs
} from 'vant'

import axios from 'axios'

import {
  formatDate
} from '../assets/date.js'
Vue.use(NavBar)
Vue.use(List)
Vue.use(Tab).use(Tabs)
export default {
  data() {
    return {
      active: 0,
      loading: false,
      finished: false,
      page: 0,
      user_id: localStorage.getItem('user_id'),
      cardlist: []
    }
  },
  created() {

  },
  filters: {
    formatDate: function(time) {
      if (time != null && time != '') {
        var date = new Date(time)
        var time = formatDate(date, 'yyyy-MM-dd')
        return time
      } else {
        return ''
      }
    }
  },
  methods: {
    gomonitoringresults(id) {
      let that = this
      that.$router.push({
        path: '/monitoringresults',
        query: {
          id: id
        }
      })
    },
    //重写
    rewrite(item) {
      let that = this
      that.$router.push({
        path: '/fillvoucher2',
        query: {
          item: localStorage.setItem('item', JSON.stringify(item))
        }
      })
    },
    //加载数据
    onLoad() {
      let that = this
      // 异步更新数据
      setTimeout(() => {
        that.page++
        that.$http.api.findMeAll({
          user_id: this.user_id,
          page: that.page,
          size: 10
        }).then(function(response) {
          console.log(response.rows)
          for (let i = 0; i < response.rows.length; i++) {
            console.log(response.rows[i])
            that.cardlist.push(response.rows[i])
          }
          console.log(that.cardlist,111)
          // 加载状态结束
          that.loading = false
          // 数据全部加载完成
          if (response.rows.length == 0) {
            console.log('进来啊啊' + response.rows.length)
            that.finished = true
          }
        })
      }, 500)
    },
    // 返回
    onClickLeft() {
      this.$router.go(-1)
    },
    //跳转填写
    gofillin() {
      let that = this
      localStorage.removeItem('item')
      that.$router.push({
        path: '/fillvoucher2'
      })
    }
  }
}
</script>
<style>
	.mytestcard .van-ellipsis {
		font-size: 12px;
	}

	.mytestcard .van-tabs__line {
		background-color: #60B0E3 !important;
	}
</style>

<style scoped lang="less">
	.mytestcard {
		width: 100%;
		height: 100vh;

		.tabs {
			width: 100%;
			height: auto;

			.item {
				padding: 11px 15px;
				box-sizing: border-box;

				.ytxcard {
					flex-direction: column;
					width: 100%;
					height: auto;
					background-color: #fff;
					border-radius: 4px;
					margin-top: 10px;
					padding: 15px 10px 10px;
					box-sizing: border-box;

					.top {
						border-bottom: 1px solid #efefef;
						padding-bottom: 12px;
						box-sizing: border-box;

						.title {
							color: #222222;
							font-size: 14px;
							margin-bottom: 10px;
						}

						.nametime {
							color: #666666;
							font-size: 12px;

							span {
								margin-right: 20px;
							}
						}
					}

					.bottom {
						display: flex;
						display: -webkit-flex;
						justify-content: flex-end;

						.btn {
							line-height: 25px;
							border-radius: 12px;
							height: 25px;
							font-size: 10px;
							padding: 0px 14px;
							box-sizing: border-box;
							font-weight: bold;
							font-size: 10px;
							margin-top: 10px;
						}

						.retx {
							border: 1px solid #49BAFF;
							color: #49BAFF;
						}

						.lookread {
							background-color: #49BAFF;
							color: #fff;
							margin-left: 10px;
						}
					}
				}

				.jck {
					border-radius: 4px;
					width: 100%;
					height: 44px;
					background-color: #fff;
					display: flex;
					display: -webkit-flex;
					justify-content: space-between;
					align-items: center;
					padding: 0px 10px;
					box-sizing: border-box;

					.left {
						font-size: 14px;
						color: #222222;
					}

					.txbtn {
						width: 66px;
						height: 24px;
						line-height: 24px;
						border-radius: 12px;
						background-color: #FF5B81;
						color: #fff;
						font-size: 10px;
						font-weight: bold;
						text-align: center;

					}
				}
			}
		}
	}
</style>
